import axios from 'axios';
import { getEnv } from '../config';

const API_URL = getEnv('REACT_APP_API_URL') || '';

export const mapAPI = {
    getMapData: () => axios.get(`${API_URL}/api/map-data`),
};
